(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/company-name-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/company-name-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const COMPANY_NAME = svs.ticket_partner.sharedComponents.input.constants.names.COMPANY_NAME;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.COMPANY_NAME,
  LABEL = _svs$ticket_partner$s.LABEL,
  MAX = _svs$ticket_partner$s.MAX,
  MAX_ERROR = _svs$ticket_partner$s.MAX_ERROR,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const CompanyNameInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    disabled: disabled,
    errorMessageMax: MAX_ERROR,
    errorMessageRequired: REQUIRED_ERROR,
    id: COMPANY_NAME,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    max: MAX,
    name: COMPANY_NAME,
    onChange: handleChange,
    value: state[COMPANY_NAME]
  });
};
svs.ticket_partner.sharedComponents.input.CompanyNameInput = CompanyNameInput;

 })(window);